import {
  urlRamos,
  urlSucursales,
  urlActualizarDisclaimer
} from "../../constants/urls";
export const RAMOS_HAS_ERRORED = "RAMOS_HAS_ERRORED";
export const SET_DATA_RAMOS = "SET_DATA_RAMOS";
export const RAMOS_LOADING = "RAMOS_LOADING";
export const SUCURSAL_HAS_ERRORED = "SUCURSAL_HAS_ERRORED";
export const SET_DATA_SUCURSAL = "SET_DATA_SUCURSAL";
export const SUCURSAL_LOADING = "SUCURSAL_LOADING";

export const DISCLAIMER_HAS_ERRORED = "DISCLAIMER_HAS_ERRORED";
export const DISCLAIMER_IS_LOADING = "DISCLAIMER_IS_LOADING";
export const UPDATE_DISCLAIMER_OK = "UPDATE_DISCLAIMER_OK";
export const LIMPIAR_DISCLAIMER = "LIMPIAR_DISCLAIMER";
export const UPDATE_SUCURSAL_SELECCIONADA = "UPDATE_SUCURSAL_SELECCIONADA";

const disclaimerError = () => ({ type: DISCLAIMER_HAS_ERRORED });
const disclaimerLoading = () => ({ type: DISCLAIMER_IS_LOADING });
const sucursalisLoading = () => ({ type: SUCURSAL_LOADING });
const ramosisLoading = () => ({ type: RAMOS_LOADING });
export const limpiarDisclaimer = () => ({ type: LIMPIAR_DISCLAIMER });
export const updateDisclaimerOK = (payload) => ({ type: UPDATE_DISCLAIMER_OK, payload })
export const updateSucursalSeleccionada = (payload) => ({ type: UPDATE_SUCURSAL_SELECCIONADA, payload })
export const sucursalError = (bool) => ({ type: SUCURSAL_HAS_ERRORED, sucursalError: bool })
export const setDataSucursal = (valor) => ({ type: SET_DATA_SUCURSAL, setDataSucursal: valor })
export const ramosError = (bool) => ({ type: RAMOS_HAS_ERRORED, ramosError: bool })
export const setDataRamos = (valor) => ({ type: SET_DATA_RAMOS, setDataRamos: valor })

export const ramosFetch = () => {
  return dispatch => {
    dispatch(ramosisLoading());
    fetch(urlRamos)
      .then(response => response.json())
      .then(data => {
        const transaccion = data.transaccion;
        if (transaccion) {
          var ramos = [];
          ramos = data.ramos;
          dispatch(setDataRamos(ramos));
        } else {
          dispatch(ramosError(""));
        }
      })
      .catch(() => {
        dispatch(ramosError(""));
      });
  };
};

export const sucursalesFetch = () => {
  return dispatch => {
    dispatch(sucursalisLoading());
    fetch(urlSucursales)
      .then(response => response.json())
      .then(data => {
        const transaccion = data.transaccion;
        if (transaccion) {
          var sucursales = [];
          sucursales = data.sucursales;
          dispatch(setDataSucursal(sucursales));
        } else {
          dispatch(sucursalError(""));
        }
      })
      .catch(() => {
        dispatch(sucursalError(""));
      });
  };
};

export const actualizarDisclaimerFecth = body => {
  return dispatch => {
    dispatch(disclaimerLoading());
    fetch(urlActualizarDisclaimer + body)
      .then(response => response.json())
      .then(data => {
        const transaccion = data.transaccion;
        if (transaccion) {
          dispatch(updateDisclaimerOK(true));
        } else {
          dispatch(disclaimerError());
        }
      })
      .catch(() => {
        dispatch(disclaimerError());
      });
  };
};
